export default "__VITE_ASSET__DvLcOUQz__"